;
define("header_menu.tpl", function(){});

